import {useState} from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import AddressField from '../common/AddressField';
import CustomTextField from '../common/CustomTextField';

import {useCreateLocationMutation} from '../../redux/services/locationApi';


const handleSubmit = ({create, setFormData}) => async formData => {
  console.log('Creating location', formData);
  const response = await create(formData);
  if (response.error) {
    console.error('Failed to create location', response.error);
  } else {
    setFormData({
      address_line_1: '',
      address_line_2: '',
      address_city: '',
      address_state: '',
      address_zip: '',
      lat: null,
      lon: null,
      name: null,
    });
  }
};

const NewLocationForm = props => {
  const [formData, setFormData] = useState({
    address_line_1: '',
    address_line_2: '',
    address_city: '',
    address_state: '',
    address_zip: '',
    lat: null,
    lon: null,
    name: null,
  });
  const [create] = useCreateLocationMutation();
  const onSubmit = handleSubmit({create, setFormData});
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
          <Typography variant='h2'>New Location</Typography>
      </Grid>
      <Grid item xs={12}>
        <CustomTextField
          name="name"
          label="Name"
          variant='outlined'
          placeholder="Name of the location"
          type="text"
          value={formData.name}
          onChange={e => setFormData({...formData, name: e.target.value})}
        />
      </Grid>
      <Grid item xs={12}>
        <AddressField
          editable={false}
          useGeocoding={true}
          onChange={address => setFormData({...FormData, ...address})}
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          variant='contained'
          onClick={() => onSubmit(formData)}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default NewLocationForm